import { render, staticRenderFns } from "./FormAddUser.vue?vue&type=template&id=59734e71"
import script from "./FormAddUser.vue?vue&type=script&lang=js"
export * from "./FormAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports